import script from "./MDialogs.vue?vue&type=script&setup=true&lang=js"
export * from "./MDialogs.vue?vue&type=script&setup=true&lang=js"

import "./MDialogs.vue?vue&type=style&index=0&id=e5f92c16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5f92c16"]])

export default __exports__